function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 7.79507C0.042521 9.80263 0.16158 13.2364 0.178588 13.6151C0.238968 14.4248 0.54597 15.2432 1.02391 15.8202C1.68894 16.6299 2.50789 16.9914 3.65001 16.9914C5.22839 17 6.96835 17 8.65814 17C10.3547 17 12.0011 17 13.3916 16.9914C14.5175 16.9914 15.362 16.6205 16.0185 15.8202C16.4965 15.2432 16.8035 14.4163 16.8468 13.6151C16.8638 13.2966 16.9489 9.56908 16.9999 7.79507H0Z",
  fill: "#FFDD02"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.86218 11.4923V12.6034C7.86218 12.9589 8.14792 13.2474 8.5 13.2474C8.85207 13.2474 9.13781 12.9589 9.13781 12.6034V11.4923C9.13781 11.1368 8.85207 10.8483 8.5 10.8483C8.14792 10.8483 7.86218 11.1368 7.86218 11.4923Z",
  fill: "#2A2A2F"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.98293 10.7814C6.89789 11.0931 6.60109 11.2923 6.27963 11.2494C4.11021 10.9437 2.03688 10.1666 0.286714 8.9997C0.107275 8.88121 0.00012207 8.67856 0.00012207 8.46218V5.48603C0.00012207 3.68283 1.45604 2.21622 3.24618 2.21622H4.91896C5.07884 0.969437 6.12485 0 7.40219 0H9.59797C10.8745 0 11.9213 0.969437 12.0812 2.21622H13.7625C15.5475 2.21622 17 3.68283 17 5.48603V8.46218C17 8.67856 16.892 8.88035 16.7143 8.9997C14.9607 10.1718 12.8789 10.9523 10.695 11.2571C10.6653 11.2614 10.6363 11.2632 10.6074 11.2632C10.3191 11.2632 10.0615 11.0665 9.98917 10.778C9.81738 10.0945 9.20253 9.61623 8.49583 9.61623C7.77977 9.61623 7.17172 10.0842 6.98293 10.7814ZM9.59788 1.28796H7.40209C6.82976 1.28796 6.35182 1.68295 6.20895 2.21618H10.7902C10.6473 1.68295 10.1694 1.28796 9.59788 1.28796Z",
  fill: "white"
});

var SvgWork = function SvgWork(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWork, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Work.076dc1ca.svg";
export { ForwardRef as ReactComponent };